import { render, staticRenderFns } from "./PatAccountPage.vue?vue&type=template&id=49c43f3e"
import script from "./PatAccountPage.vue?vue&type=script&lang=js"
export * from "./PatAccountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports